import Main from "./Main";
import theme from "./theme";
import DIP from "./components/DIP";
import { store } from "./redux/store";
import { Provider } from "react-redux";
import { isMobile } from "react-device-detect";
import PopUpManager from "components/PopUpManager";
import DebugMenu from "./debug/components/DebugMenuDev";
import DebugClock from "./debug/components/DebugClock";
import FacebookProvider from "./contexts/FacebookProvider";
import WebStoreProvider from "./contexts/WebStoreProvider";
import { DebugActions } from "debug/components/DebugActions";
import GoogleAnalyticsProvider from "./contexts/GoogleAnalyticsProvider";
import ScopelyIdentityProvider from "./contexts/ScopelyIdentityProvider";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import StickyBackToGameButton from "components/Buttons/StickyBackToGameButton";
import WebstoreHttpServiceProvider from "./contexts/WebstoreHttpServiceProvider";
import PopUpManagerV2 from "components/PopUpManagerV2";
import { UnLoggedRedirection } from "routes/UnLoggedRedirection";
import { PushNotificationsProvider } from "./contexts/PushNotificationsProvider";
import { UserSegmentsGate } from "contexts/UserSegmentsGate";
import FloatingBottomLayer from "components/FloatingBottomLayer";

const AppContent = (): JSX.Element => {
	const isDebugMode = process.env.REACT_APP_WITH_DEBUG === "true";

	// TEMP DEBUG: force a runtime error only in debug mode using ?errorBoundaryTest=1
	if (typeof window !== "undefined") {
		const params = new URLSearchParams(window.location.search);
		if (isDebugMode && params.get("errorBoundaryTest") === "1") {
			throw new Error("Simulated ErrorBoundary test error");
		}
	}

	return (
		<Provider store={store}>
			<DebugActions>
				<WebstoreHttpServiceProvider>
					<GoogleAnalyticsProvider>
						<FacebookProvider>
							<ScopelyIdentityProvider>
								<WebStoreProvider>
									<UserSegmentsGate>
										<StyledEngineProvider injectFirst>
											<UnLoggedRedirection>
												<ThemeProvider theme={theme}>
													<PushNotificationsProvider>
														<Main />
														{isDebugMode && <DebugClock />}
														<DIP />
														<PopUpManager />
														<PopUpManagerV2 />
														<FloatingBottomLayer />
														{isMobile && (
															<StickyBackToGameButton source="sticky_button" />
														)}
														{isDebugMode && <DebugMenu />}
													</PushNotificationsProvider>
												</ThemeProvider>
											</UnLoggedRedirection>
										</StyledEngineProvider>
									</UserSegmentsGate>
								</WebStoreProvider>
							</ScopelyIdentityProvider>
						</FacebookProvider>
					</GoogleAnalyticsProvider>
				</WebstoreHttpServiceProvider>
			</DebugActions>
		</Provider>
	);
};

export default AppContent;
